<template>
    <div id="Block">
        <b-modal id="modBlock" no-close-on-backdrop no-close-on-esc>
            <template v-slot:modal-header>
                {{ $t("REASON")}}
                <b-button size="sm" @click="close()">
                    x
                </b-button>
            </template>
            <b-form-input v-model="reason" placeholder=""></b-form-input>
            <template v-slot:modal-footer>
                <b-button @click="save()">
                    {{ $t("SAVE")}}
                </b-button>
                <b-button @click="close()">
                    {{ $t("CLOSE")}}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { BModal, BButton, BFormInput } from 'bootstrap-vue';

export default {
  name: 'Block',
  components: {
    BModal, BButton, BFormInput
  },
  props: {
    userName: String,
    itemName: String,
    itemType: String
  },
  data: function() {
    return {
        reason: ''
    }
  },
  mounted() {
    this.block();
  },
  methods: {
    async block() {
        this.$bvModal.show('modBlock');
    },
    async save() {
        this.$bvModal.hide('modBlock')
        let url = this.itemType === 'places' ? 'blockPlace' : '/blockTrip';
        try {
            const response = await this.$http.get(url, {
                params: {
                    itemName: this.itemName,
                    userName: this.userName,
                    blockReason: this.reason
                }
            });
            this.$showMsg(response.data);
            this.close();
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    close() {
        this.$bvModal.hide('modBlock');
        this.$emit('reloadList');

    }
  }
}
</script>